import { Box, Button, Collapse, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AdvancedSearchProps = {
  formExpanded: boolean;
  title: string;
  content: JSX.Element;
  resetCallback: () => void;
  onSearch?: () => void;
  disable?: boolean;
  showButtonActions?: boolean;
  gridSpacing?: number;
};

export const AdvancedSearch = (props: AdvancedSearchProps) => {
  const { formExpanded, title, content, onSearch, resetCallback, disable = false, showButtonActions = true, gridSpacing = 2 } = props;
  const { t } = useTranslation();
  const useCustomHandler = typeof onSearch === 'function';

  const resetAll = () => {
    resetCallback();
  };

  return (
    <Box sx={{ mx: 2 }}>
      <Collapse in={formExpanded}>
        <Grid container spacing={gridSpacing} mt={1}>
          <Grid item xs={12}>
            <Box
              sx={{
                p: 2,
                backgroundColor: (thm) => thm.palette.background.default,
                borderRadius: 1,
                border: `1px solid rgba(0,0,0,0.05)`,
              }}
            >
              <Box sx={{ mt: -3.5, pb: 1 }}>
                <Typography
                  sx={{ fontWeight: 500, px: 0.5, backgroundColor: '#fff', lineHeight: 1, borderRadius: 1, textTransform: 'uppercase' }}
                  component='span'
                  variant='subtitle2'
                >
                  {title}
                </Typography>
              </Box>
              <Grid item xs={12}>
                {content}
              </Grid>
            </Box>
          </Grid>

          {showButtonActions && (
            <Grid item xs={12} display='flex' justifyContent='flex-end' gap={2} mb={2}>
              <Button variant='outlined' disableElevation onClick={() => resetAll()}>
                {t('common:button.reset')}
              </Button>
              <Button
                type={useCustomHandler ? 'button' : 'submit'}
                onClick={useCustomHandler ? onSearch : undefined}
                variant='contained'
                disableElevation
                disabled={disable}
              >
                {t('common:button.search')}
              </Button>
            </Grid>
          )}
        </Grid>
      </Collapse>
    </Box>
  );
};
